import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col } from "shards-react";

import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarSearch from "./SidebarSearch";
import SidebarNavItems from "./SidebarNavItemsUser";

import appStore from "../../core/app.store";
import nav_store from "../../core/sidenav.store";

class UserSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: appStore.getState().app.menuVisible !== false,
      sidebarNavItems: [],
    };
    this.onMenuChange = this.onMenuChange.bind(this);
  }

  componentDidMount() {
    this.menuUnsubscribe = appStore.subscribe(this.onMenuChange);
    this.setState({ sidebarNavItems: nav_store.getState().sidenav.sideNavItems });
    this.navUnsubscribe = nav_store.subscribe(() => {
      this.setState({ sidebarNavItems: nav_store.getState().sidenav.sideNavItems });
    });
  }

  componentWillUnmount() {
    if (this.menuUnsubscribe) this.menuUnsubscribe();
    if (this.navUnsubscribe) this.navUnsubscribe();
  }

  onMenuChange() {
    this.setState({ menuVisible: appStore.getState().app.menuVisible !== false });
  }

  render() {
    const { sidebarNavItems } = this.state;

    const classes = classNames("main-sidebar", "px-0", "col-12", this.state.menuVisible && "open");

    return (
      <Col tag="aside" className={classes} lg={{ size: 2 }} md={{ size: 3 }}>
        <SidebarMainNavbar hideLogoText={this.props.hideLogoText} />
        <SidebarSearch />
        <SidebarNavItems sidebarNavItems={sidebarNavItems} />
      </Col>
    );
  }
}

UserSidebar.propTypes = {
  hideLogoText: PropTypes.bool,
};

UserSidebar.defaultProps = {
  hideLogoText: false,
};

export default UserSidebar;
